import { createActions, handleActions } from 'redux-actions';

import * as loadingState from '@coconut/constants/loadingState';

export const types = {
  START_SESSION: 'START_SESSION',
  START_SESSION_SUCCESS: 'START_SESSION_SUCCESS',
  START_SESSION_FAILED: 'START_SESSION_FAILED',
};

export const { startSession, startSessionSuccess, startSessionFailed } =
  createActions(
    {
      [types.START_SESSION]: (userID, QID) => ({
        userID,
        QID,
      }),
    },
    types.START_SESSION_SUCCESS,
    types.START_SESSION_FAILED
  );

const INIT_STATE = {
  errorMessage: '',
  loadingStatus: loadingState.EMPTY,
};

const reducer = handleActions(
  {
    [types.START_SESSION]: (state) => ({
      ...state,
      loadingStatus: loadingState.LOADING,
    }),
    [types.START_SESSION_SUCCESS]: (state) => ({
      ...state,
      loadingStatus: loadingState.READY,
      errorMessage: '',
    }),
    [types.START_SESSION_FAILED]: (state, action) => ({
      ...state,
      loadingStatus: loadingState.READY,
      errorMessage: action.payload.errorMessage,
    }),
  },
  INIT_STATE
);

export default reducer;



// WEBPACK FOOTER //
// ./src/scenes/Chat/services/redux/startSession.js